import { render, staticRenderFns } from "./TaskNewDataTable.vue?vue&type=template&id=3f1dd45c&scoped=true"
import script from "./TaskNewDataTable.vue?vue&type=script&lang=js"
export * from "./TaskNewDataTable.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDataTable.vue?vue&type=style&index=0&id=3f1dd45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1dd45c",
  null
  
)

export default component.exports